
export class AssetTypeOption {
  id?: number;
  optionName?: string;
  description?: string;
  assetTypeId?: number;
}
